export default "__VITE_ASSET__DFlJ1cP3__"